export enum CompetitionTypeEnum {
  Invalid = 0,
  ResearchProjectCompetition = 1,
  ScholarshipProgram = 2,
  MobileTechnics = 3,
}
